import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// import { APIService } from '../../../API.service';
import { ChallengeSummaryService } from '../../challenge-summary.service';
// import { ChallengesComponent } from '../../challenges/challenges.component';

@Component({
  selector: 'app-cn-reset-popup',
  templateUrl: './cn-reset-popup.component.html',
  styleUrls: ['./cn-reset-popup.component.scss']
})
export class CnResetPopupComponent implements OnInit {

  reset_confirm: string = '';

  constructor(public allChallenge: ChallengeSummaryService,public router: Router) { }

  ngOnInit(): void {
    this.deleteConfirm();
  }

  public waytoPDF() { 
    $('.pdf-modal').css('display','block')
    // console.log(window.location);
      localStorage.setItem('pdf_type','allContent');
    // this.router.navigate(['/challenges/summary']);
    // this.challengeComponent.arguments('allContent');
    // window.open(window.location.origin + '/challenges/summary','_blank');
  }

  public async deleteConfirm() {
    if(this.reset_confirm == 'RESET'){
      $('.loader-container').css('display','flex');
     await this.waytoPDF()
     setTimeout(() => {   // need 10 sec timer because passing in lambda taking few sec
       this.resetData();
       this.close();
     }, 10000); 
  }
}
  public async resetData(){
    localStorage.removeItem('CN_FRAMEWORKS');
    this.router.navigate(['/challenges/ideate']);
    setTimeout(() => {
      this.router.navigate(['/challenges/clarify']);
      $('.loader-container').css('display','none');
    }, 500);
  }

  public resetValue(e) {
    this.reset_confirm = e.target.value;
  }

  public close(){
    $('.reset-modal').css('display','none');
  }

}
